import {BaseModel, AttributeDescriptor, BaseModelDescriptor} from "./BaseModel";
import {ValidationTypes} from "../core/Validator";

export class Contact extends BaseModel {
	id: string
	title: string
	email: string
	phone: string;
	customerId: string;
}

export class ContactDescriptor extends BaseModelDescriptor{
	static id: AttributeDescriptor = {validation: []}
	static title: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
	static email: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED, ValidationTypes.EMAIL]}
	static phone: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED, ValidationTypes.PHONE]}
}
